/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit AutoSignOutTimeout/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import Body from 'DesignSystem/Body/index'
import Countdown from 'DesignSystem/Countdown/react'
import React from 'react'
import Timeout from 'DesignSystem/Timeout/react'



/** @type {import('Simple/types.js').View} */
export default function AutoSignOutTimeout({
  children,
  viewPath = "/App/Account/InactivityWarning/Content/AutoSignOutTimeout",
  onChange
  
}) {
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let constantData = 'For security reasons, you\'ll be automatically signed out in'
let countdownCurrentValueData = fromData.useDataValue({ viewPath,
context: 'countdown',
path: 'current',
})
let constantData1 = 'seconds'
let aggregateData = fromAggregate.join(constantData, countdownCurrentValueData, constantData1)
let countdownCurrentChangeData = fromData.useDataChange({ viewPath,
context: 'countdown',
path: 'current',
})
  return (<React.Fragment
>
<Body
  viewPath={`${viewPath}/Body`}
 marginTop={4}
 data="'For security reasons, you\\'ll be automatically signed out in'"
 data="countdown.current"
 data="'seconds'"
 aggregate="/Data/aggregate.js join"
 text={aggregateData}
/>
<Timeout
  viewPath={`${viewPath}/Timeout`}
 onTimeout={() => setFlowTo("/App/Auth/SignOut")}
 delay={29000}
/>
<Countdown
  viewPath={`${viewPath}/Countdown`}
 data="countdown.current"
 onChange={countdownCurrentChangeData}
 every={1000}
 countFrom={30}
 countTo={0}
/>
{children}
</React.Fragment>)
}